<template>
  <transition
    :enterActiveClass="$style.slideEnterActive"
    :enterClass="$style.slideEnter"
    :leaveActiveClass="$style.slideLeaveActive"
    :leaveToClass="$style.slideLeaveTo"
  >
    <div
      v-show="articleSuggestions.length"
      :class="$style.kbContainer"
    >
      <h4
        :class="$style.kbTitle"
      >
        Articles that might help
      </h4>
      <ul :class="$style.kbList">
        <li
          v-for="(article, index) in articleSuggestions"
          :key="article.id"
          :class="$style.kbLinks"
          @click="() => handleItemClick(index)"
        >
          <CollapsableSection
            :class="$style.collapse"
            :collapse="index !== selectedIndex"
            :delayTransition="true"
            :showCaret="true"
            :showSectionCards="false"
            :title="article.title"
          >
            {{ articleBody(article) }}...
            <br>
            <a
              :class="$style.readMoreLink"
              :href="`https://support.jumpcloud.com/support/s/article/${article.url}`"
              rel="noopener noreferrer"
              target="_blank"
              @click="() => handleLinkClick(article)"
            >
              read more
            </a>
          </CollapsableSection>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { KnowledgeBaseConsts } from 'client/util/Constants';
import { debounce } from 'lodash';
import { events } from 'client/GrowthEngineering/utilities/GrowthConstants';
import CollapsableSection from 'components/ContentSection/CollapsableSection.vue';
import EventManager from 'client/GrowthEngineering/EventManager';
import KnowledgeApi, { isValidSearchTerm } from 'api/v2/KnowledgeApi';

const { kbFields } = KnowledgeBaseConsts;

export default {
  name: 'ContactSupportKbArticles',

  components: {
    CollapsableSection,
  },

  props: {
    initTrigger: {
      required: true,
      type: Function,
    },
    subject: {
      required: true,
      type: String,
    },
  },

  debounce,
  data() {
    return {
      selectedIndex: 0,
      articleSuggestions: [],
    };
  },

  watch: {
    subject() {
      // only search after a space
      if (this.subject.endsWith(' ')) {
        this.askForArticleSuggestionsFunc();
      }
    },
  },

  created() {
    this.askForArticleSuggestionsFunc = this.$options.debounce(
      this.askForArticleSuggestions,
      500,
      { leading: true, trailing: true },
    );

    this.initTrigger(this.askForArticleSuggestions);
  },

  methods: {
    articleBody(article) {
      if (article && article.body) {
        return article.body.substring(0, 250);
      }
      return '';
    },

    askForArticleSuggestions() {
      if (isValidSearchTerm(this.subject)) {
        const {
          id,
          body,
          title,
          url,
        } = kbFields;
        KnowledgeApi.fetch(
          [id, body, title, url],
          {
            searchTerm: this.subject,
            limit: 3,
          },
        )
          .then((resp) => {
            this.articleSuggestions = resp.results;
          })
          .catch(() => {
            this.articleSuggestions = [];
          });
      }
    },

    handleItemClick(index) {
      if (index === this.selectedIndex) {
        this.selectedIndex = undefined;
      } else {
        this.selectedIndex = index;
      }
    },

    handleLinkClick(article) {
      const kbClickedLink = `https://support.jumpcloud.com/support/s/article/${article.url}`;
      const payload = {
        fullSearch: this.subject,
        kbClickedLink,
      };
      const { triggerEvent } = EventManager;
      triggerEvent(events.submitSupportTicketKbLinkClicked, payload);
    },
  },
};
</script>

<style scoped module>
.collapse {
  padding: 10px 31px;
}

.kbContainer {
  padding: 0 60px;
}

.kbLinks {
  list-style: none;
  margin-bottom: 15px;
}

.kbList {
  padding-left: 0;
}

.kbTitle {
  margin-bottom: 25px;
  text-align: center;
}

.readMoreLink {
  float: right;
}

.slideEnterActive,
.slideLeaveActive {
  height: 300px;
  transition: all 0.25s;
}

.slideEnter,
.slideLeaveTo {
  height: 0;
  opacity: 0;
}
</style>
